import { ReportViewerDataType } from 'app/report/ReportViewer';
import { AnyElementsViewerDataType } from 'components/element-viewer';
import { ChartMetricsInfoType } from 'components/metric/MetricViewer';
import { useKpiChartBlockSummaryStats } from 'components/report-content/components/kpi-chart/hooks/useKpiChartBlockSummaryStats';

// Report elements only: finds the single component flagged as the tile-preview component
// (rendererBlocks is absent for other element types).
export function useReportPreviewSummaryStats(
    viewerExtraData: AnyElementsViewerDataType,
    elementId: number,
    segmentValueId: number,
): ChartMetricsInfoType | null {
    const rendererBlocks = (viewerExtraData as ReportViewerDataType | undefined)?.rendererBlocks;
    const previewBlock = rendererBlocks?.find((b) => b.component.settings.is_preview_ind == 'Y');

    return useKpiChartBlockSummaryStats(
        previewBlock
            ? { internalName: previewBlock.component.internalName, settings: previewBlock.component.settings }
            : undefined,
        (viewerExtraData as ReportViewerDataType | undefined)?.displayMasks ?? [],
        elementId,
        segmentValueId,
    );
}
